import React from "react";
import "./Map.css";

export default function Map() {
  return (
    <div className="map">
      <iframe
        title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1163.1717229827855!2d28.307026829231614!3d-15.411394706448482!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x283b1ef2abccfde8!2zMTXCsDI0JzQxLjAiUyAyOMKwMTgnMjcuMyJF!5e1!3m2!1sen!2szm!4v1658851458719!5m2!1sen!2szm"
        width="800"
        height="600"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
